import { Pipe, PipeTransform } from "@angular/core";
import { ServiceService } from "../../providers/services.service";

@Pipe({
  name: "group_service",
})
export class GroupServicePipe implements PipeTransform {

  constructor(
    private serviceData: ServiceService,
  ) { }

  public transform(idGroup: string, clientId: string, eventId: string) {
    return this.serviceData.getGroupById(clientId, idGroup, eventId);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/group-service/group-service.ts